import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Info } from "lucide-react";

/**
 * iter210 — "Why X Days?" drill-down popover.
 * Consumes emp.attendanceCounts + emp.unmarkedDays which the payroll
 * snapshot already computes via the SAME unified resolver the
 * Attendance Dashboard uses.  Any mismatch here between the badge and
 * the SA-expected value ⇒ real attendance-data problem for that
 * employee — not a resolver mismatch.
 */
export function WhyDaysPopover({ emp }) {
  const c = emp.attendanceCounts || {};
  const dim = emp.daysInMonth || 0;
  const unmarked = emp.unmarkedDays || 0;
  const payable = emp.presentDays || 0;
  const rows = [
    ["Present (P)", c.P || 0, "1.0"],
    ["Half Day (HD)", c.HD || 0, "0.5"],
    ["Week Off (WO)", c.WO || 0, "1.0"],
    ["Late (LATE)", c.LATE || 0, "1.0"],
    ["Leave (L)", c.L || 0, "0.0"],
    ["Absent (A)", c.A || 0, "0.0"],
    ["Not-marked", (c.NM || 0) + unmarked, "0.0"],
  ];
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="ml-1 text-slate-400 hover:text-slate-700 inline-flex align-middle"
                 data-testid={`why-days-${emp.employeeName}`}
                 title={`Why ${payable}/${dim} days?`}>
          <Info className="w-3.5 h-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64" align="end">
        <div className="text-xs font-semibold mb-2">
          {emp.employeeName} — {payable}/{dim} payable days
        </div>
        <table className="w-full text-[11px]">
          <thead>
            <tr className="text-slate-500 border-b">
              <th className="text-left py-1 font-normal">Status</th>
              <th className="text-right py-1 font-normal">Count</th>
              <th className="text-right py-1 font-normal">Weight</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(([label, count, weight]) => (
              <tr key={label} className="border-b border-slate-100">
                <td className="py-0.5">{label}</td>
                <td className="text-right">{count}</td>
                <td className="text-right text-slate-500">{weight}</td>
              </tr>
            ))}
            <tr className="font-semibold">
              <td className="py-1">Total payable</td>
              <td className="text-right">{payable}</td>
              <td className="text-right text-slate-500">/ {dim}</td>
            </tr>
          </tbody>
        </table>
        <div className="mt-2 text-[10px] text-slate-500 leading-tight">
          Resolver: <code>{emp.attendance_source || "LIVE"}</code>.
          Same source as the Attendance Dashboard. If this differs from
          what SA expects, the underlying attendance rows for the month
          need fixing (not the payroll formula).
        </div>
      </PopoverContent>
    </Popover>
  );
}
